import React from 'react';
import {
  TextButtonPriority as TEXT_BUTTON_PRIORITY,
  TextButton,
  Tooltip,
  TooltipSkin,
} from 'wix-ui-tpa/cssVars';
import Text, { TextType } from '../../Text/Text';
import { TagName } from '../../../../utils/tagName.const';
import { classes } from './ParticipantActionButton.st.css';
import { ParticipantActionButtonDataHooks } from './dataHooks';

export interface ParticipantActionButtonProps {
  label: string;
  icon: React.ReactElement;
  onClick: () => void;
  disabled?: boolean;
  tooltipContent?: string;
  dataHook?: string;
  // Small secondary line under the button (e.g. "5 spots left").
  hint?: string;
}

const ParticipantActionButton: React.FC<ParticipantActionButtonProps> = ({
  label,
  icon,
  onClick,
  disabled,
  tooltipContent,
  dataHook,
  hint,
}) => {
  const button = (
    <TextButton
      priority={TEXT_BUTTON_PRIORITY.primary}
      className={classes.button}
      data-hook={dataHook}
      disabled={disabled}
      onClick={onClick}
      prefixIcon={icon}
    >
      {label}
    </TextButton>
  );

  return (
    <div className={classes.root}>
      {tooltipContent ? (
        <Tooltip
          skin={TooltipSkin.Wired}
          content={tooltipContent}
          minWidth={200}
          data-hook={ParticipantActionButtonDataHooks.TOOLTIP}
        >
          {button}
        </Tooltip>
      ) : (
        button
      )}
      {hint && (
        <Text
          type={TextType.Secondary}
          tagName={TagName.Paragraph}
          className={classes.hint}
          data-hook={ParticipantActionButtonDataHooks.HINT}
        >
          {hint}
        </Text>
      )}
    </div>
  );
};

export default ParticipantActionButton;
